export default "__VITE_ASSET__5BqIrp3O__"